export default "__VITE_ASSET__40bc3da1__"